import React from 'react';
import { CheckCircle, Archive } from 'lucide-react';
import SalleCard from './SalleCard';

const SalleSection = ({ 
  title, 
  icon: Icon, 
  salles, 
  isArchived = false,
  onEdit, 
  onArchive, 
  onRestore, 
  onDelete,
  showPagination = false,
  pagination = null
}) => {
  if (salles.length === 0) return null;

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
        <Icon className="h-5 w-5 mr-2" />
        {title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {salles.map((salle) => (
          <SalleCard
            key={salle.id}
            salle={salle}
            isArchived={isArchived}
            onEdit={onEdit}
            onArchive={onArchive}
            onRestore={onRestore}
            onDelete={onDelete}
          />
        ))}
      </div>
      {showPagination && pagination}
    </div>
  );
};

export default SalleSection; 